import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { RestockDateService } from 'common/data';

class RestockDateStore extends BaseStore {
	constructor(rootStore) {
		super(new RestockDateService(rootStore.app.baasic.apiClient));
	}

	@action
	createRestockDate = async (restockDateParams, sourceOfChange) => {
		const response = await this.service.createRestockDate(restockDateParams, sourceOfChange);
		return response.data;
	};

	@action
	updateRestockDate = async (restockDateParams, sourceOfChange) => {
		const response = await this.service.updateRestockDate(restockDateParams, sourceOfChange);
		return response.data;
	};
}

export default RestockDateStore;



// WEBPACK FOOTER //
// ./src/modules/restock-date/stores/RestockDateStore.js